import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineNewspaperIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 11h-1a1.0001 1.0001 0 0 0 0 2h1a1.0001 1.0001 0 0 0 0-2Zm0 4h-1a1.0001 1.0001 0 0 0 0 2h1a1.0001 1.0001 0 0 0 0-2Zm-6-6h6a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2Zm10-6H7a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h13a3.9996 3.9996 0 0 0 2.8284-1.1716A3.9996 3.9996 0 0 0 22 17V4a1.0002 1.0002 0 0 0-1-1ZM6 18a1 1 0 1 1-2 0V9h2v9Zm14-1a2 2 0 0 1-2 2H7.82A3.0003 3.0003 0 0 0 8 18V5h12v12Zm-9-4h1a1.0001 1.0001 0 0 0 0-2h-1a1.0001 1.0001 0 0 0 0 2Zm0 4h1a1.0001 1.0001 0 0 0 0-2h-1a1.0001 1.0001 0 0 0 0 2Z"/>
  </SvgIcon>
}

export default LineNewspaperIcon
